<div class="dialog">
  <h2>Filter configuration storage</h2>

  <p>
    When enabled, we store your filter configuration on our servers every time you sync, copy, save, or download a filter while logged in to your pathofexile.com account.
  </p>
  <p>
    <strong>What we store:</strong> the filter configuration, filter name, and version. Your PoE username is optional.
  </p>
  <p>
    <strong>What this enables:</strong>
  </p>
  <ul>
    <li>It allows you to share your filters or cosmetics with others through a direct link.</li>
    <li>Aggregated filter data helps us improve default filter settings and thus the overall usefulness of the tool for everyone.</li>
    <li>When you reach out to us with a question or bug report, we can use your filter to reproduce and help resolve the issue.</li>
  </ul>
  <p>
    <strong>Why store your username?</strong>
  </p>
  <ul>
    <li>It allows your username to be included when you publicly share your filter.</li>
    <li>It helps us quickly find your filter when you contact us.</li>
  </ul>
  <p>
    You can change your choice at any time on the <a href="/settings">Settings</a> tab.
  </p>

  <div class="dialog-toggle table-checkbox-group regular-checkbox inline" (click)="allowUsername = !allowUsername">
    <span class="input-group-btn">
      <button type="button" class="btn toggle-btn" [class.off]="!allowUsername"></button>
    </span>
    <span class="table-checkbox-label" style="margin-left: 8px">Also store my pathofexile.com username {{ username() ? '(' + username() + ')' : '' }}</span>
  </div>

  <div class="controls dialog-controls">
    <button type="button" class="btn dialog-btn dialog-main-btn" (click)="allow.emit(allowUsername)">Allow</button>
    <button type="button" class="btn dialog-btn" (click)="optOut.emit()">Opt out</button>
    <button type="button" class="btn dialog-btn dialog-cancel-btn" (click)="close.emit()">Close</button>
  </div>
</div>
